import {useMutation, useQueryClient} from 'react-query';
import EmptyStyleGuarantor from './emptyGuarantor';
import {GetGuaranteedLoans} from '../../../../services/guarantor.service';
import {
    GetGuaranteedLoansResponse,
    ILoans,
} from '../../../../models/guarantor.model';
import {useEffect, useState} from 'react';
import LoanCard from '../../../../components/card/loanCard/loanCard';
import ElementTitle from '../../../../components/title/elementTitle/elementTitle';
import {IInnerStateHomeMenu} from '../IHomeMenu';
import {useDispatch} from 'react-redux';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {GUARANTOR_INFO} from '../../../../config/cacheKey';
import LoansSkeleton from '../../loansTab/Loans/loansSkeleton';

export default function Guarantor({setState}: IInnerStateHomeMenu) {
    const [data, setData] = useState<GetGuaranteedLoansResponse[]>();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const queryClient = useQueryClient();
    const {mutateAsync: GetGuaranteedLoansMutate, isLoading} = useMutation(
        GetGuaranteedLoans,
        {
            onSuccess: (data) => {
                setData(data);
            },
        }
    );
    const handleLoanCard = (guarantorInfo: ILoans) => {
        queryClient.setQueryData(GUARANTOR_INFO, guarantorInfo);
        setState!('guarantorDetail');
    };
    useEffect(() => {
        dispatch(
            setHeaderTitle({
                color: 'var(--header-color)',
                header: 'شما ضامن شده اید',
                parentRoute: 'home',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({prevInnerState: `home ${randomKeyForDispatch}`})
        );

        GetGuaranteedLoansMutate();
    }, []);
    if (isLoading) {
        return <LoansSkeleton />;
    }
    return (
        <div className="p-5">
            {data && data.length > 0 ? (
                <>
                    {data?.map((item, index) => (
                        <>
                            <div className="mb-2">
                                <ElementTitle
                                    title={
                                        item.customerFullName
                                            ? `تسهیلات "${item.customerFullName}"`
                                            : ''
                                    }
                                />
                            </div>
                            {item.loans.map((item) => (
                                <LoanCard
                                    key={index}
                                    status={
                                        item?.inProgress
                                            ? 'other'
                                            : item?.loanRequestStatus
                                    }
                                    onClick={() => handleLoanCard(item)}
                                    price={String(
                                        item?.amount.toLocaleString()
                                    )}
                                    financialProvider={
                                        item?.financialSupplierTitle
                                    }
                                    financialSupplierLogoUrl={
                                        item?.financialSupplier
                                    }
                                    insallmentStep={item?.durationTitle}
                                    inProgress={String(item?.inProgress)}
                                    statusTitle={item?.loanRequestStatusTitle}
                                />
                            ))}
                        </>
                    ))}
                </>
            ) : (
                <EmptyStyleGuarantor />
            )}
        </div>
    );
}
